/**
 * The purpose of this service is to handle all Ouber-related API requests, 
 * centralizing communication for drivers, vehicles, trips, and trip requests.
 */
export class OuberService {
  constructor(fetchData) {
    this.fetchData = fetchData;
  }

  // --- Drivers ---
  async getDrivers(params = {}) {
    return await this.fetchData({
      url: "ouber/drivers",
      method: "GET",
      params,
    });
  }

  async createDriver(data) {
    return await this.fetchData({
      url: "ouber/drivers",
      method: "POST",
      data,
    });
  }

  async updateDriver(id, data) {
    return await this.fetchData({
      url: `ouber/drivers/${id}`,
      method: "PATCH",
      data,
    });
  }

  async deleteDriver(id) {
    return await this.fetchData({
      url: `ouber/drivers/${id}`,
      method: "DELETE",
    });
  }

  // --- Vehicles ---
  async getVehicles(params = {}) {
    return await this.fetchData({
      url: "ouber/vehicles",
      method: "GET",
      params,
    });
  }

  async createVehicle(data) {
    return await this.fetchData({
      url: "ouber/vehicles",
      method: "POST",
      data,
    });
  }

  async updateVehicle(id, data) {
    return await this.fetchData({
      url: `ouber/vehicles/${id}`,
      method: "PATCH",
      data,
    });
  }

  async deleteVehicle(id) {
    return await this.fetchData({
      url: `ouber/vehicles/${id}`,
      method: "DELETE",
    });
  }

  // --- Trips ---
  async getTrips(params = {}) {
    return await this.fetchData({
      url: "ouber/trips",
      method: "GET",
      params,
    });
  }

  async createTrip(data) {
    return await this.fetchData({
      url: "ouber/trips",
      method: "POST",
      data,
    });
  }

  async updateTrip(id, data) {
    return await this.fetchData({
      url: `ouber/trips/${id}`,
      method: "PATCH",
      data,
    });
  }

  async getTripDetails(id) {
    return await this.fetchData({
      url: `ouber/trips/${id}`,
      method: "GET",
    });
  }

  async deleteTrip(id) {
    return await this.fetchData({
      url: `ouber/trips/${id}`,
      method: "DELETE",
    });
  }

  // --- Trip Requests ---
  async getTripRequests(params = {}) {
    return await this.fetchData({
      url: "ouber/trip-requests",
      method: "GET",
      params,
    });
  }

  async createTripRequest(data) {
    return await this.fetchData({
      url: "ouber/trip-requests",
      method: "POST",
      data,
    });
  }

  async updateRequestStatus(id, data) {
    // Expects { request_status: "Approved" } or "Rejected"
    return await this.fetchData({
      url: `ouber/trip-requests/${id}`,
      method: "PATCH",
      data,
    });
  }

  async deleteTripRequest(id) {
    return await this.fetchData({
      url: `ouber/trip-requests/${id}`,
      method: "DELETE",
    });
  }
}
